import React from 'react'
// libs
import styled from 'styled-components'
import { FieldArray, reduxForm } from 'redux-form'
// constants
import { Forms } from 'constants/forms'
// components
import AppetiteOption from './components/AppetiteOption'
// types
import { MatrixOption } from 'components/Modals/MatrixModal/components/Matrix/types'
import { InjectedFormProps } from 'redux-form/lib/reduxForm'

const Form = styled.form`
  display: flex;
  flex-direction: column;
`

interface Props {
  matrixOptions: MatrixOption[]
}

const AppetiteOptionsForm: React.FC<InjectedFormProps<Props> & Props> = ({ handleSubmit, matrixOptions }) => {
  return (
    <Form onSubmit={handleSubmit}>
      <FieldArray<any> name='options' component={AppetiteOption} matrixOptions={matrixOptions} />
    </Form>
  )
}

export default reduxForm<any, any>({ form: Forms.RISK_MATRIX_APPETITE_FORM })(AppetiteOptionsForm)
